import { FaturamentoCreditoFinanceiro } from './faturamento-credito-financeiro.model';
import { FaturamentoCumprimentoPpb } from './faturamento-cumprimento-ppb.model';

export class FaturamentoCreditoFinanceiroVO {

  faturamento: FaturamentoCreditoFinanceiro;
  faturamentoCumprimento: FaturamentoCumprimentoPpb;
  idFaturamentoProdutoCreditoFinanceiro: number;
}
